import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';

/**
 * Hands values only the JS side knows to the stylesheet, as CSS custom
 * properties on <html>. This keeps the auth modals pure CSS: no component
 * overrides, and it also covers the lazy-loaded Sign Up modal.
 *
 * Must run after app.forum is loaded, i.e. from app.beforeMount().
 */
export default function exposeThemeVars() {
  const root = document.documentElement;

  // The forum's own logos, shown above the auth modal titles (less/forum/auth.less).
  const logo = app.forum.attribute('logoUrl');
  const logoDark = app.forum.attribute('logoDarkModeUrl') || logo;
  if (logo) {
    root.style.setProperty('--bd-logo-light', cssUrl(logo));
    root.style.setProperty('--bd-logo-dark', cssUrl(logoDark || logo));
    root.classList.add('bd-has-logo');
  }

  // The word between the social log-in buttons and the form.
  root.style.setProperty('--bd-or-label', JSON.stringify(extractText(app.translator.trans('bimmerdock-theme.forum.auth.or'))));
}
function cssUrl(url) {
  return `url(${JSON.stringify(url)})`;
}